import React from 'react';
import styled from 'styled-components';
import { POSPaymentButton } from './POSButton';

const CheckoutContainer = styled.div`
  background: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme.colors?.card?.background || 'rgba(255, 255, 255, 0.05)'
      : '#ffffff'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? props.theme.colors?.card?.border || 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.1)'};
  border-radius: ${(props) => props.theme.borderRadius?.lg || '12px'};
  overflow: hidden;
`;

const CheckoutBody = styled.div`
  padding: 20px;
`;

const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 14px;
  font-family: 'Barlow Condensed', sans-serif;
  font-size: 20px;
  font-weight: 500;
  color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme.colors?.text?.primary || '#ffffff'
      : '#000033'};

  ${(props) =>
    props.isTotal &&
    `
    font-size: 28px;
    font-weight: 700;
    margin-top: 20px;
    margin-bottom: 0;
    padding-top: 20px;
    border-top: 1px solid ${
      props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.1)'
    };
  `}
`;

const PaymentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

/**
 * POSCheckoutCard - A checkout summary card for POS interfaces
 *
 * @param {Object} props
 * @param {string} props.subtotal - Formatted subtotal string
 * @param {string} props.fees - Formatted fees string
 * @param {string} props.discount - Formatted discount string (optional)
 * @param {string} props.total - Formatted total string
 * @param {boolean} props.showCard - Whether to show card payment option
 * @param {boolean} props.showCash - Whether to show cash payment option
 * @param {Function} props.onCardPayment - Callback for card payment
 * @param {Function} props.onCashPayment - Callback for cash payment
 * @param {boolean} props.disabled - Whether payment buttons are disabled
 */
const POSCheckoutCard = ({
  subtotal = '$0.00',
  fees = '$0.00',
  discount,
  total = '$0.00',
  showCard = true,
  showCash = true,
  onCardPayment,
  onCashPayment,
  disabled = false,
}) => {
  return (
    <CheckoutContainer>
      <CheckoutBody>
        <SummaryRow>
          <span>Subtotal</span>
          <span>{subtotal}</span>
        </SummaryRow>
        <SummaryRow>
          <span>Fees</span>
          <span>{fees}</span>
        </SummaryRow>
        {discount && (
          <SummaryRow>
            <span>Discount</span>
            <span>-{discount}</span>
          </SummaryRow>
        )}
        <SummaryRow isTotal>
          <span>Total</span>
          <span>{total}</span>
        </SummaryRow>

        <PaymentGrid>
          {showCard && (
            <POSPaymentButton
              variant="primary"
              onClick={onCardPayment}
              disabled={disabled}
            >
              Credit / Debit
            </POSPaymentButton>
          )}
          {showCash && (
            <POSPaymentButton
              variant="outlined"
              onClick={onCashPayment}
              disabled={disabled}
            >
              Cash
            </POSPaymentButton>
          )}
        </PaymentGrid>
      </CheckoutBody>
    </CheckoutContainer>
  );
};

export default POSCheckoutCard;
